import Api from "../../api";

import { VehicleStatus } from "./models.jsx";

class VehicleStatusApi extends Api {
	
	get(callback) {
		var url = this.baseUrl;

		this.client.get(url)
			.then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new VehicleStatus(response.data[index]));
				}

				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

}

class VehicleApi{

	constructor(baseUrl) {
		this.status = new VehicleStatusApi(baseUrl);
	}

}


export default VehicleApi;